export enum KeyboardCodes {
    ArrowUp = 'ArrowUp',
    ArrowDown = 'ArrowDown',
    Escape = 'Escape',
}
